import React, { useEffect, useState } from 'react';
import axios from 'axios';
import {
  FaRegEdit,
  FaUser,
  FaEnvelope,
  FaQrcode,
  FaRegAddressCard,
  FaChartBar,
} from 'react-icons/fa';
import { FaSpinner, FaPlus, FaUtensils, FaArrowLeft } from 'react-icons/fa';

import { useParams } from 'react-router-dom';

const api = axios.create({
  baseURL: 'https://twiqli-server-vercel.vercel.app/api',
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
  },
});

const RestaurantDashboard = () => {
  const [dashboardData, setDashboardData] = useState(null);
  const [loading, setLoading] = useState(true);
  const { restaurantId } = useParams();
  const token = localStorage.getItem('ownerToken');

  useEffect(() => {
    const fetchDashboardData = async () => {
      try {
        const response = await api.get(
          `/restaurants/restaurant/${restaurantId}/dashboard`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );
        console.log(response.data);
        setDashboardData(response.data);
        setLoading(false);
      } catch (error) {
        console.error('Error fetching dashboard data:', error);
        setLoading(false);
      }
    };

    fetchDashboardData();
  }, [restaurantId, token]);

  const handleDownloadQRCode = (qrCodeUrl) => {
    const link = document.createElement('a');
    link.href = qrCodeUrl;
    link.download = 'restaurant_qrcode.png';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  // return (
  //   <div className='container mx-auto px-4 py-8 max-w-[1200px]'>
  //     <div className='columns-1 md:columns-2 lg:columns-3 gap-6 space-y-4'>
  //       <div className='bg-gradient-to-r from-blue-500 to-indigo-500 p-6 shadow-lg rounded-lg text-white break-inside-avoid mb-4'>
  //         <h2 className='text-2xl font-bold mb-4 flex items-center'>
  //           <FaUser className='mr-3' /> Recent Subscribed Customers
  //         </h2>
  //         <ul>
  //           {dashboardData.customers.map((customer, i) => (
  //             <li key={customer._id} className='py-2 border-b border-gray-200'>
  //               {customer.phoneNumber}
  //             </li>
  //           ))}
  //         </ul>
  //       </div>

  //       <div className='bg-gradient-to-r from-purple-500 to-pink-500 p-6 shadow-lg rounded-lg text-white break-inside-avoid mb-4'>
  //         <h2 className='text-2xl font-bold mb-4 flex items-center'>
  //           <FaQrcode className='mr-3' /> QR Code
  //         </h2>
  //         <img
  //           src={dashboardData.restaurantDetails.qrCode}
  //           alt='QR Code'
  //           className='w-full h-auto'
  //         />
  //         <button
  //           className='m mt-4 bg-indigo-600 hover:bg-indigo-700 text-white font-semibold py-2 px-4 rounded transition duration-200'
  //           onClick={() => {
  //             handleDownloadQRCode(dashboardData.restaurantDetails.qrCode);
  //           }}
  //         >
  //           <FaRegEdit className='mr-2 inline' />
  //           Download QR Code
  //         </button>
  //         {/* <button className='mt-4 bg-indigo-600 hover:bg-indigo-700 text-white font-semibold py-2 px-4 rounded transition duration-200'>
  //           <FaRegEdit className='mr-2 inline' /> Edit Restaurant Information
  //         </button> */}
  //       </div>

  //       <div className='bg-gradient-to-r from-yellow-400 to-orange-500 p-6 shadow-lg rounded-lg text-white break-inside-avoid mb-4'>
  //         <h2 className='text-2xl font-bold mb-4 flex items-center'>
  //           <FaRegAddressCard className='mr-3' /> Welcome Message
  //         </h2>
  //         <p>{dashboardData.restaurantDetails.welcomeMessage}</p>
  //         <button className='mt-4 bg-indigo-600 hover:bg-indigo-700 text-white font-semibold py-2 px-4 rounded transition duration-200'>
  //           <FaRegEdit className='mr-2 inline' /> Edit Welcome Message
  //         </button>
  //       </div>

  //       <div className='bg-gradient-to-r from-green-400 to-teal-500 p-6 shadow-lg rounded-lg text-white overflow-y-auto break-inside-avoid mb-4'>
  //         <h2 className='text-2xl font-bold mb-4 flex items-center'>
  //           <FaEnvelope className='mr-3' /> Recent Text Messages
  //         </h2>
  //         <ul>
  //           {dashboardData.recentMessages.map((message) => (
  //             <div
  //               key={message._id}
  //               className='bg-white shadow-lg p-4 rounded mb-3 text-gray-700'
  //             >
  //               <h2 className='text-lg font-semibold text-gray-700'>
  //                 {message.content}
  //               </h2>
  //               <p className='text-sm text-gray-500'>
  //                 Scheduled Date:{' '}
  //                 {new Date(message.scheduledDate).toLocaleString()}
  //               </p>
  //               <p className='text-sm text-gray-500'>
  //                 Status: {message.status}
  //               </p>
  //             </div>
  //           ))}
  //         </ul>
  //       </div>

  //       <div className='bg-gradient-to-r from-red-400 to-red-600 p-6 shadow-lg rounded-lg text-white break-inside-avoid mb-4'>
  //         <h2 className='text-2xl font-bold mb-4 flex items-center'>
  //           <FaRegAddressCard className='mr-3' /> Opt-Out Word
  //         </h2>
  //         <p>{dashboardData.restaurantDetails.optOutWord}</p>
  //         <button className='mt-4 bg-indigo-600 hover:bg-indigo-700 text-white font-semibold py-2 px-4 rounded transition duration-200'>
  //           <FaRegEdit className='mr-2 inline' /> Edit Opt-Out Word
  //         </button>
  //       </div>

  //       <div className='bg-gradient-to-r from-gray-600 to-gray-800 p-6 shadow-lg rounded-lg text-white break-inside-avoid mb-4'>
  //         <h2 className='text-2xl font-bold mb-4 flex items-center'>
  //           <FaRegAddressCard className='mr-3' /> Restaurant Details
  //         </h2>
  //         <p>Name: {dashboardData.restaurantDetails.name}</p>
  //         <button className='mt-4 bg-indigo-600 hover:bg-indigo-700 text-white font-semibold py-2 px-4 rounded transition duration-200'>
  //           <FaRegEdit className='mr-2 inline' /> Edit Restaurant Information
  //         </button>
  //       </div>
  //     </div>
  //   </div>
  // );

  if (loading) {
    return (
      <div className='flex justify-center items-center h-screen'>
        <FaSpinner className='animate-spin text-4xl text-blue-500' />
      </div>
    );
  }

  return (
    <div className='container mx-auto px-4 py-8 max-w-[1200px]'>
      <div className='columns-1 md:columns-2 lg:columns-3 gap-6 space-y-4'>
        {/* Total Subscribed Customers */}
        <div className='bg-gradient-to-r from-blue-600 to-blue-400 p-6 shadow-lg rounded-lg text-white break-inside-avoid mb-4'>
          <h2 className='text-2xl font-bold mb-4 flex items-center'>
            <FaChartBar className='mr-3' /> Total Subscribed Customers
          </h2>
          <p className='text-4xl font-bold'>{dashboardData.totalSubscribers}</p>
        </div>

        {/* Total Sent Text Messages */}
        <div className='bg-gradient-to-r from-green-600 to-teal-500 p-6 shadow-lg rounded-lg text-white break-inside-avoid mb-4'>
          <h2 className='text-2xl font-bold mb-4 flex items-center'>
            <FaEnvelope className='mr-3' /> Total Sent Text Messages
          </h2>
          <p className='text-4xl font-bold'>
            {dashboardData.totalTextMessagesSent}
          </p>
        </div>

        {/* Recent Subscribed Customers */}
        <div className='bg-gradient-to-r from-blue-500 to-indigo-500 p-6 shadow-lg rounded-lg text-white break-inside-avoid mb-4'>
          <h2 className='text-2xl font-bold mb-4 flex items-center'>
            <FaUser className='mr-3' /> Recent Subscribed Customers
          </h2>
          <ul>
            {dashboardData.customers.map((customer, i) => (
              <li key={customer._id} className='py-2 border-b border-gray-200'>
                {customer.phoneNumber}
              </li>
            ))}
          </ul>
        </div>

        {/* QR Code */}
        <div className='bg-gradient-to-r from-purple-500 to-pink-500 p-6 shadow-lg rounded-lg text-white break-inside-avoid mb-4'>
          <h2 className='text-2xl font-bold mb-4 flex items-center'>
            <FaQrcode className='mr-3' /> QR Code
          </h2>
          <img
            src={dashboardData.restaurantDetails.qrCode}
            alt='QR Code'
            className='w-full h-auto'
          />
        </div>

        {/* Welcome Message */}
        <div className='bg-gradient-to-r from-yellow-400 to-orange-500 p-6 shadow-lg rounded-lg text-white break-inside-avoid mb-4'>
          <h2 className='text-2xl font-bold mb-4 flex items-center'>
            <FaRegAddressCard className='mr-3' /> Welcome Message
          </h2>
          <p>"{dashboardData.welcomeMessage?.content}"</p>
          <button className='mt-4 bg-indigo-600 hover:bg-indigo-700 text-white font-semibold py-2 px-4 rounded transition duration-200'>
            <FaRegEdit className='mr-2 inline' /> Edit Welcome Message
          </button>
        </div>

        {/* Recent Text Messages */}
        <div className='max-h-[650px] bg-gradient-to-r from-green-400 to-teal-500 p-6 shadow-lg rounded-lg text-white overflow-y-auto break-inside-avoid mb-4'>
          <h2 className='text-2xl font-bold mb-4 flex items-center'>
            <FaEnvelope className='mr-3' /> Recent Text Messages
          </h2>
          <ul>
            {dashboardData.recentMessages.map((message) => (
              <div
                key={message._id}
                className='bg-white shadow-lg p-4 rounded mb-3 text-gray-700'
              >
                <h2 className='text-base font-semibold text-gray-700'>
                  {message.content}
                </h2>
                {/* <img className='text-base font-semibold text-gray-700'>
                  {message.imageurl}
                </img> */}
                <p className='text-sm text-gray-500'>
                  Scheduled Date:{' '}
                  {new Date(message.scheduledDate).toLocaleString()}
                </p>
                <p className='text-sm text-gray-500'>
                  Status: {message.status}
                </p>
              </div>
            ))}
          </ul>
        </div>

        {/* Opt-Out Word */}
        <div className='bg-gradient-to-r from-red-400 to-red-600 p-6 shadow-lg rounded-lg text-white break-inside-avoid mb-4'>
          <h2 className='text-2xl font-bold mb-4 flex items-center'>
            <FaRegAddressCard className='mr-3' /> Opt-Out Word
          </h2>
          <p>
            Reply "OPT OUT {dashboardData.restaurantDetails.optOutWord} to
            unsubscribe."
          </p>
          <button className='mt-4 bg-indigo-600 hover:bg-indigo-700 text-white font-semibold py-2 px-4 rounded transition duration-200'>
            <FaRegEdit className='mr-2 inline' /> Edit Opt-Out Word
          </button>
        </div>

        {/* Restaurant Details */}
        <div className='bg-gradient-to-r from-gray-600 to-gray-800 p-6 shadow-lg rounded-lg text-white break-inside-avoid mb-4'>
          <h2 className='text-2xl font-bold mb-4 flex items-center'>
            <FaRegAddressCard className='mr-3' /> Restaurant Details
          </h2>
          <p>Name: {dashboardData.restaurantDetails.name}</p>
          <button className='mt-4 bg-indigo-600 hover:bg-indigo-700 text-white font-semibold py-2 px-4 rounded transition duration-200'>
            <FaRegEdit className='mr-2 inline' /> Edit Restaurant Information
          </button>
        </div>
      </div>
    </div>
  );
};

export default RestaurantDashboard;
